import React from 'react'
import store from '../../helpers/store'
import AntiFraud from '../../components/form-components/anti-fraud.component'
import Container from '../../components/layout/container.component'
import PaymentStep from './components/payment-step.component'
import ProgressBar from '../../components/progress-bar/progress-bar.container'
import TicketSaleTitle from './components/ticket-sale-title.component'
import ConfirmationStep from './components/confirmation-step.component'
import OriginSelectStep from './components/origin-select-step.component'
import TicketSaleSelectors from '../../ducks/ticket-sale/ticket-sale.selectors'
import DestinationSelectStep from './components/destination-select-step.component'
import { routes } from '../../constants/routes.constants'
import { connect } from 'react-redux'
import { withRouter, Redirect } from 'react-router-dom'
import { toastActions } from '../../actions/toast.actions'
import { ticketSaleSteps } from './../../constants/ticket-sale.constants'
import { bindActionCreators } from 'redux'
import { Creators as TripPriceCreators } from '../../ducks/trip-price/trip-price'
import { Creators as TicketSaleCreators } from '../../ducks/ticket-sale/ticket-sale'
import { Creators as ProgressBarCreators } from '../../ducks/progress-bar/progress-bar'

class TicketSale extends React.Component {
	componentDidMount() {
		this.props.getServiceCharge()
		this.props.fetchTripPriceConversionParameters()
	}

	componentWillMount() {
		const { setCurrent, hasReturnTrip } = this.props

		const current = getCurrent(hasReturnTrip)
		setCurrent(current)
	}

	render() {
		// Rendered as a declarative <Redirect> (not history.push() during a
		// lifecycle method) so react-router handles the transition as part of
		// this same render pass instead of triggering a second, nested update
		// while this page is still mounting - which was dropping the loading
		// spinner that performSearchTrips had already turned on.
		//
		// The pathname check is required because render() (unlike the
		// componentWillMount this replaced) re-runs on every update: once the
		// redirect below lands on /cliente/compra-de-passagem, this component
		// renders again with the same logged-in user, and without the check
		// it would redirect to itself forever - looping before OriginSelectStep
		// ever gets to render the trips that had already arrived.
		const alreadyOnClientRoute = document.location.pathname.startsWith(
			routes.CLIENTE
		)

		if (this.props.user !== null && !alreadyOnClientRoute) {
			const path = `${routes.CLIENTE}${routes.COMPRA_DE_PASSAGEM}${document.location.search}`
			return <Redirect to={path} push />
		}

		return (
			<Container medium>
				<AntiFraud />
				<TicketSaleTitle />
				<ProgressBar items={getItems(this.props)} />
			</Container>
		)
	}
}

function getCurrent(hasReturnTrip) {
	const { saleStep } = store.getState().ticketSale
	switch (saleStep) {
		case ticketSaleSteps.busSeatSelectionReturn:
			return 1
		case ticketSaleSteps.payment:
			return 1 + hasReturnTrip
		case ticketSaleSteps.confirmation:
			return 2 + hasReturnTrip
		default:
			return 0
	}
}

function getItems({ hasReturnTrip, goToNextStep }) {
	const payment = {
		title: 'Pagamento',
		Content: props => (
			<PaymentStep
				nextStep={props.nextStep}
				previousStep={props.previousStep}
			/>
		)
	}

	const confirmation = {
		title: 'Confirmação',
		Content: ConfirmationStep
	}

	const items = [
		{
			title: 'Seleção da ida',
			Content: props => (
				<OriginSelectStep
					nextStep={() => (goToNextStep(), props.nextStep())}
				/>
			)
		}
	]

	if (hasReturnTrip) {
		const destinationSelect = {
			title: 'Seleção da volta',
			Content: props => (
				<DestinationSelectStep
					previousStep={props.previousStep}
					nextStep={() => (goToNextStep(), props.nextStep())}
				/>
			)
		}

		items.push(destinationSelect)
	}

	items.push(payment, confirmation)

	return items
}

const mapStateToProps = store => ({
	user: store.user,
	deviceId: store.antiFraud.sessionID,
	hasReturnTrip: TicketSaleSelectors.hasReturnTrip(store),
	isConfirmationStep: TicketSaleSelectors.isConfirmationStep(store)
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			setCurrent: ProgressBarCreators.setCurrent,
			goToNextStep: TicketSaleCreators.goToNextStep,
			getServiceCharge: TicketSaleCreators.getServiceCharge,
			fetchTripPriceConversionParameters: TripPriceCreators.fetchData
		},
		dispatch
	)

const connectedTicketSale = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(TicketSale)
)

export { connectedTicketSale as ModuleRootComponent }
